// Logical canvas size in pixels (square 1:1)
export const CANVAS_SIZE = 1024;

export const uid = () =>
  Math.random().toString(36).slice(2, 9) + Date.now().toString(36).slice(-4);

// Read a File into a data URL
export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Load image and get natural dimensions
export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Compute initial layer placement based on natural dimensions
export function computeLayerSize(natW, natH) {
  const max = CANVAS_SIZE * 0.6;
  let w = natW, h = natH;
  const ratio = w / h;
  if (w > max || h > max) {
    if (w > h) { w = max; h = max / ratio; }
    else { h = max; w = max * ratio; }
  }
  // Add slight randomized rotation for scrapbook feel
  const rotation = (Math.random() - 0.5) * 8; // -4..4 deg
  // Slight off-center placement
  const jitterX = (Math.random() - 0.5) * 80;
  const jitterY = (Math.random() - 0.5) * 80;
  return {
    width: Math.round(w),
    height: Math.round(h),
    x: Math.round((CANVAS_SIZE - w) / 2 + jitterX),
    y: Math.round((CANVAS_SIZE - h) / 2 + jitterY),
    rotation,
  };
}

// Convert client (mouse/touch) coords to canvas-logical coords
export function getLogicalCoords(clientX, clientY, canvasEl) {
  const rect = canvasEl.getBoundingClientRect();
  const scale = rect.width / CANVAS_SIZE;
  return {
    x: (clientX - rect.left) / scale,
    y: (clientY - rect.top) / scale,
    scale,
  };
}

// Build CSS background string from background config
export function buildBackgroundCSS(bg) {
  if (!bg) return { background: '#ffffff' };
  if (bg.type === 'transparent') return { background: 'transparent' };
  if (bg.type === 'solid') return { background: bg.color };
  if (bg.type === 'gradient') {
    return { background: `linear-gradient(${bg.angle}deg, ${bg.from}, ${bg.to})` };
  }
  if (bg.type === 'image' && bg.src) {
    return {
      backgroundImage: `url(${bg.src})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  }
  return { background: '#ffffff' };
}

export const PRESET_COLORS = [
  '#FFFFFF', '#FDFBF7', '#0A0A0A', '#D9CDF7', '#BEE3CC',
  '#FFD4C2', '#FFE08A', '#FF8A8A', '#A7D8FF', '#1F1F2E',
];

export const PRESET_GRADIENTS = [
  { from: '#D9CDF7', to: '#FFD4C2', angle: 135 },
  { from: '#BEE3CC', to: '#A7D8FF', angle: 135 },
  { from: '#FFE08A', to: '#FF8A8A', angle: 135 },
  { from: '#0A0A0A', to: '#1F1F2E', angle: 135 },
  { from: '#FFFFFF', to: '#D9CDF7', angle: 180 },
  { from: '#FF8A8A', to: '#D9CDF7', angle: 90 },
];
